var exports = {
  "kL": "VoiceStateIcons.module__container___b2NyQ2",
  "Kk": "VoiceStateIcons.module__icon___b2NyQ2",
  "bU": "VoiceStateIcons.module__iconMuted___b2NyQ2",
  "DP": "VoiceStateIcons.module__iconGuildAction___b2NyQ2",
};

module.exports = exports;
